// extracted by mini-css-extract-plugin
module.exports = {"card":"TextField_card__3E3hB","label":"TextField_label__2EU2E","value":"TextField_value__21ka8"};